import { FormField } from "@client/controls/Form/Field/component";
import AddressInput from "@client/controls/Inputs/TextInput/Address/component";
import { validatePhone } from "@common/components/Form/Field/lib";
import { FancyCheckbox } from "@common/controls/Inputs/Checkbox/component";
import { useI18n } from "@common/hooks/i18n";
import { i18nFormatHtml } from "@common/lib/i18n";
import { validators } from "@common/lib/validate";
import React from "react";
import { type Leaderboard } from "../../types";

export type ActionProps = {
  onPrivacyClick: () => void;
  onTermsClick: () => void;
};
export type MapProps = {
  hasPrivacy: boolean;
  hasTerms: boolean;
  values: Leaderboard.View.UserData;
};
export default (props: ActionProps & MapProps) => {
  const i18n = useI18n();

  return (
    <>
      <FormField
        Component={AddressInput}
        isRequired
        label={i18n.firstName}
        name="firstName"
        value={props.values.firstName}
      />
      <FormField
        Component={AddressInput}
        isRequired
        label={i18n.lastName}
        name="lastName"
        value={props.values.lastName}
      />
      <FormField
        Component={AddressInput}
        isRequired
        label={i18n.email}
        name="email"
        value={props.values.email}
        validator={validators.email}
      />
      <FormField
        Component={AddressInput}
        isRequired
        label={i18n.telephone}
        name="telephone"
        value={props.values.telephone}
        validator={validatePhone}
      />
      {props.hasTerms && (
        <FormField
          Component={FancyCheckbox}
          componentProps={{
            label: i18nFormatHtml(i18n.termsAndConditionsField, [
              "TERMS",
              {
                caption: i18n.terms,
                className: "text_link",
                onClick: (e) => (e.stopPropagation(), props.onTermsClick())
              }
            ])
          }}
          isRequired
          label={null}
          name="hasAcceptedTerms"
          value={props.values.hasAcceptedTerms}
        />
      )}
      {props.hasPrivacy && (
        <FormField
          Component={FancyCheckbox}
          componentProps={{
            label: i18nFormatHtml(i18n.privacyPolicyField, [
              "PRIVACY_POLICY",
              {
                caption: i18n.privacyPolicy,
                className: "text_link",
                onClick: (e) => (e.stopPropagation(), props.onPrivacyClick())
              }
            ])
          }}
          isRequired
          label={null}
          name="hasAcceptedPrivacy"
          value={props.values.hasAcceptedPrivacy}
        />
      )}
      <FormField
        Component={FancyCheckbox}
        componentProps={{ label: i18n.receiveMarketingCommunication }}
        label={null}
        name="hasAcceptedMarketing"
        value={props.values.hasAcceptedMarketing}
      />
    </>
  );
};
